var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStrategyBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#DDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 22.8242V22.8262V35.3729C39.1 38.3775 36.6565 40.8329 33.6401 40.8329H22.3467C19.3429 40.8329 16.8867 38.3767 16.8867 35.3729V22.8262C16.8867 21.3039 17.2414 19.9986 17.9182 19.0701C18.5801 18.1621 19.5767 17.5757 20.971 17.5068L21.4474 18.3007L21.8762 18.0435L21.4474 18.3007C22.0799 19.355 23.2192 20 24.4486 20H31.5515C32.7809 20 33.9202 19.355 34.5527 18.3007L35.0291 17.5068C36.4178 17.5756 37.4142 18.1593 38.0757 19.0656C38.7519 19.992 39.1062 21.2966 39.1 22.8242Z",
    fill: "#064AD3",
    stroke: "#064AD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.14 15.1689L33.14 15.1689V15.1737V16.427C33.14 17.5375 32.2439 18.4337 31.1333 18.4337H24.8533C23.7428 18.4337 22.8467 17.5375 22.8467 16.427V15.1737C22.8467 14.0666 23.7527 13.167 24.8667 13.167H31.1333C32.2483 13.167 33.1506 14.0665 33.14 15.1689Z",
    fill: "#4683FC",
    stroke: "#4683FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3824 23.75H20.6176C20.3661 23.75 20.25 23.5885 20.25 23.5C20.25 23.4115 20.3661 23.25 20.6176 23.25H26.3824C26.6339 23.25 26.75 23.4115 26.75 23.5C26.75 23.5885 26.6339 23.75 26.3824 23.75Z",
    fill: "#DDE8FF",
    stroke: "#DDE8FF",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4898 26.75H20.5102C20.3646 26.75 20.25 26.6305 20.25 26.5C20.25 26.3695 20.3646 26.25 20.5102 26.25H23.4898C23.6354 26.25 23.75 26.3695 23.75 26.5C23.75 26.6305 23.6354 26.75 23.4898 26.75Z",
    fill: "#DDE8FF",
    stroke: "#DDE8FF",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 35.98L25.63 32.89C25.97 32.45 26.6 32.37 27.04 32.71L28.87 34.15C29.31 34.49 29.94 34.41 30.28 33.98L32.59 31",
    stroke: "#DDE8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.25,
    cy: 30,
    r: 1.5,
    fill: "#4682FC",
    stroke: "#DDE8FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.25,
    cy: 36,
    r: 1.5,
    fill: "#4682FC",
    stroke: "#DDE8FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyBuilder);
export default __webpack_public_path__ + "static/media/StrategyBuilder.e20bb2378603d82d9345fff8eb18ae07.svg";
export { ForwardRef as ReactComponent };